import { memo } from 'react';

import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronsLeftIcon,
  ChevronsRightIcon,
  PlayIcon,
  RedoIcon,
  Volume1Icon,
  Volume2Icon,
  VolumeXIcon,
} from '@air/design-icons';

import { type Shortcut, ShortcutsList } from '~/components/ShortcutsList';

const VIDEO_SHORTCUTS: Shortcut[] = [
  {
    id: 'play-pause',
    icon: PlayIcon,
    label: 'Play/Pause video',
    keys: ['space', 'k'],
  },
  {
    id: 'forward',
    icon: ChevronsRightIcon,
    label: 'Fast forward 1x, 2x, 4x, 8x',
    keys: ['l'],
  },
  {
    id: 'rewind',
    icon: ChevronsLeftIcon,
    label: 'Rewind 1x, 2x, 4x, 8x',
    keys: ['j'],
  },
  {
    id: 'jump-forward-1-frame',
    icon: ChevronRightIcon,
    label: 'Jump 1 frame forward',
    keys: ['shift+right'],
  },
  {
    id: 'jump-backward-1-frame',
    icon: ChevronLeftIcon,
    label: 'Jump 1 frame backward',
    keys: ['shift+left'],
  },
  {
    id: 'mute',
    icon: VolumeXIcon,
    label: 'Mute',
    keys: ['m'],
  },
  {
    id: 'increase-volume',
    icon: Volume2Icon,
    label: 'Increase volume',
    keys: ['up'],
  },
  {
    id: 'decrease-volume',
    icon: Volume1Icon,
    label: 'Decrease volume',
    keys: ['down'],
  },
  {
    id: 'jump-to',
    icon: RedoIcon,
    label: 'Jump to… (10% increments)',
    keys: ['1', '9'],
    separator: '…',
  },
];

export const VideoShortcutsInfo = memo(() => {
  return <ShortcutsList shortcuts={VIDEO_SHORTCUTS} />;
});

VideoShortcutsInfo.displayName = 'VideoShortcutsInfo';
